import { getJson } from '../../utils/network';
import { networkProgress, networkFailed, resetNetwork } from '../../actions';

export const GET_INVOICES = 'GET_INVOICES';

function getInvoicesSuccess(data) {
   return {
      type: GET_INVOICES,
      invoices: data
   };
}

export function getInvoices() {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/invoices')
         .then(response => {
            dispatch(getInvoicesSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   }
}